(() => {
  'use strict';
  const returnFocus = new WeakMap();
  function setMenu(open) {
    const toggle = document.querySelector('[data-menu-toggle]');
    const panel = document.getElementById('MobileMenu');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    panel.hidden = !open;
  }
  function openDialog(dialog, opener) {
    if (!dialog?.showModal) return false;
    returnFocus.set(dialog, opener);
    dialog.showModal();
    document.body.classList.add('dialog-open');
    (dialog.querySelector('input') || dialog.querySelector('button'))?.focus();
    return true;
  }
  // Delegation also supports sections replaced inside the Shopify theme editor.
  document.addEventListener('click', event => {
    const menu = event.target.closest('[data-menu-toggle]');
    if (menu) { setMenu(menu.getAttribute('aria-expanded') !== 'true'); return; }
    const search = event.target.closest('[data-search-open]');
    if (search && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      if (openDialog(document.querySelector('[data-search-dialog]'), search)) event.preventDefault();
      return;
    }
    const story = event.target.closest('[data-story-open]');
    if (story && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      if (openDialog(document.getElementById(story.dataset.storyOpen), story)) event.preventDefault();
      return;
    }
    const close = event.target.closest('[data-search-close],[data-story-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const dialog = event.target;
    if (dialog.matches?.('dialog.search-dialog,dialog.story-dialog')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    document.querySelectorAll('.nav-dropdown[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('.search-dialog,.story-dialog')) return;
    document.body.classList.remove('dialog-open');
    const opener = returnFocus.get(event.target);
    if (opener?.isConnected) opener.focus();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector('[data-menu-toggle]')?.getAttribute('aria-expanded') === 'true') {
      setMenu(false); document.querySelector('[data-menu-toggle]').focus();
    }
  });
  window.matchMedia('(min-width: 801px)').addEventListener('change', event => { if (event.matches) setMenu(false); });
  document.addEventListener('shopify:section:select', event => {
    event.target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
})();
